import React, { useState } from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import { DAY_WEEK_TYPE } from "../../utils/constants";

export type ViewMode = (typeof DAY_WEEK_TYPE)[keyof typeof DAY_WEEK_TYPE];

interface DayWeekTabProps {
  value?: ViewMode;
  defaultValue?: ViewMode;
  onChange?: (value: ViewMode) => void;
}

const items: TabsProps["items"] = [
  {
    key: DAY_WEEK_TYPE.DAY,
    label: "Day",
  },
  {
    key: DAY_WEEK_TYPE.WEEK,
    label: "Week",
  },
];

const DayWeekTab: React.FC<DayWeekTabProps> = ({
  value,
  defaultValue = DAY_WEEK_TYPE.WEEK,
  onChange,
}) => {
  const [activeKey, setActiveKey] = useState<ViewMode>(defaultValue);

  React.useEffect(() => {
    if (value !== undefined) {
      setActiveKey(value);
    }
  }, [value]);

  const handleChange = (key: string) => {
    const val = key as ViewMode;
    if (value === undefined) {
      setActiveKey(val);
    }
    onChange?.(val);
  };

  return (
    <div className="day-week-tab-wrapper">
      <Tabs
        activeKey={activeKey}
        onChange={handleChange}
        items={items}
        type="card"
        size="small"
        className="day-week-tab"
        destroyOnHidden
      />
      <style>{`
        .day-week-tab-wrapper {
          display: inline-flex;
          align-items: center;
        }

        .day-week-tab .ant-tabs-nav {
          margin-bottom: 0;
        }

        .day-week-tab .ant-tabs-nav::before {
          display: none;
        }

        .day-week-tab .ant-tabs-nav-wrap {
          background-color: #eef0f4;
          border-radius: 50px;
          padding: 4px;
        }

        .day-week-tab .ant-tabs-nav-list {
          gap: 2px;
        }

        .day-week-tab .ant-tabs-tab {
          background: transparent !important;
          border: none !important;
          border-radius: 50px !important;
          padding: 4px 20px !important;
          margin: 0 !important;
          color: #7a8499 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          transition: all 0.25s ease !important;
          line-height: 1.5 !important;
        }

        .day-week-tab .ant-tabs-tab:hover {
          color: #5a6478 !important;
        }

        .day-week-tab .ant-tabs-tab.ant-tabs-tab-active {
          background: #ffffff !important;
          border-radius: 50px !important;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12) !important;
        }

        .day-week-tab .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #008dc4 !important;
          font-weight: 600 !important;
        }

        .day-week-tab .ant-tabs-ink-bar {
          display: none !important;
        }

        .day-week-tab .ant-tabs-content-holder {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default DayWeekTab;
